export const FILTERS_CONFIG_KEY = 'catalogFiltersConfig';
export const ITEMS_PER_PAGE_KEY = 'catalogItemsPerPage';
